// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
.input-floating {
  position: relative;
  input {
    display: block;
    height: calc(var(--spacing, 0.25rem) * 9);
    width: 100%;
    appearance: none;
    border-radius: 0.25rem;
    --tw-border-style: none;
    border-style: none;
    background-color: var(--color-white, #fff);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
    padding-block: calc(var(--spacing, 0.25rem) * 1);
    color: var(--color-gray-900, oklch(21% 0.034 264.665));
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
    outline-color: var(--color-gray-300, oklch(87.2% 0.01 258.338));
    &:hover {
      @media (hover: hover) {
        outline-color: var(--color-gray-500, oklch(55.1% 0.027 264.364));
      }
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      outline-color: var(--color-gray-500, oklch(55.1% 0.027 264.364));
    }
    &:disabled {
      cursor: not-allowed;
    }
    &:disabled {
      background-color: var(--color-gray-100, oklch(96.7% 0.003 264.542));
    }
    &:disabled {
      color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    }
  }
  label {
    pointer-events: none;
    position: absolute;
    top: calc(1 / 2 * 100%);
    left: calc(var(--spacing, 0.25rem) * 0);
    margin-bottom: calc(var(--spacing, 0.25rem) * 0) !important;
    transform-origin: 0;
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    background-color: var(--color-white, #fff);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
    color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  input:focus ~ label,
    input:not(:placeholder-shown) ~ label {
    top: calc(var(--spacing, 0.25rem) * 0);
    left: calc(var(--spacing, 0.25rem) * 0.5);
    --tw-scale-x: 90%;
    --tw-scale-y: 90%;
    --tw-scale-z: 90%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
    color: var(--color-gray-500, oklch(55.1% 0.027 264.364));
  }
  &.has-icon {
    input {
      padding-left: calc(var(--spacing, 0.25rem) * 8);
    }
    label {
      left: calc(var(--spacing, 0.25rem) * 7);
      z-index: 1;
      &:is(:where(.peer):focus ~ *) {
        left: calc(var(--spacing, 0.25rem) * 2.5);
      }
      &:is(:where(.peer):placeholder-shown ~ *) {
        left: calc(var(--spacing, 0.25rem) * 5);
      }
    }
    .input-icon {
      position: absolute;
      top: calc(1 / 2 * 100%);
      left: calc(var(--spacing, 0.25rem) * 2);
      z-index: 2;
      --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
      color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    }
  }
  &.has-clear-icon {
    input {
      padding-right: calc(var(--spacing, 0.25rem) * 8);
    }
    .clear-icon {
      position: absolute;
      top: calc(1 / 2 * 100%);
      right: calc(var(--spacing, 0.25rem) * 2);
      --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
      cursor: pointer;
      color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
      &:hover {
        @media (hover: hover) {
          color: var(--color-gray-700, oklch(37.3% 0.034 259.733));
        }
      }
    }
  }
  [ng-transclude] {
    position: absolute;
    top: calc(1 / 2 * 100%);
    right: calc(var(--spacing, 0.25rem) * 1);
    height: calc(100% - 2px);
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  &.has-error {
    input {
      border-color: var(--color-red-500, oklch(63.7% 0.237 25.331));
      &:focus {
        border-color: var(--color-red-600, oklch(57.7% 0.245 27.325));
      }
    }
    label {
      color: var(--color-red-500, oklch(63.7% 0.237 25.331));
      &:is(:where(.peer):focus ~ *) {
        color: var(--color-red-600, oklch(57.7% 0.245 27.325));
      }
    }
  }
}
.input-error-message {
  margin-top: calc(var(--spacing, 0.25rem) * 1);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-red-500, oklch(63.7% 0.237 25.331));
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-outline-style: solid;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-duration: initial;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/input-floating/input-floating.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACUyE,iBAAO;AAJhF;EACW,kBAAQ;EAEf;IACoB,cAAK;IAA+E,yCAAG;IAAjF,WAAM;IAAC,gBAAe;IAAC,sBAAO;IAAC,uBAAW;IAAX,kBAAW;IAAzD,0CAAQ;IAA2E,iDAAI;IAAC,gDAAI;IACnG,sDAAa;IADoD,sCAAO;IAAP,kBAAO;IAAC,+DAAgB;IAErD;MAAA;QAAA,gEAAsB;MAAA;IAAA;IAAnC;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAnC;MAAA,gEAAsB;IAAA;IACf;MAAA,mBAA2B;IAAA;IAAC;MAAA,mEAAoB;IAAA;IAAC;MAAA,wDAAsB;IAAA;EACjF;EAED;IACoB,oBAAmB;IAA5B,kBAAQ;IAAuC,uBAAO;IAAzB,uCAAM;IAAM,2DAAK;IACrD,mBAAW;IAAC,+CAAgB;IAAhB,sDAAgB;IAAC,0GAAS;IAAC,0CAAQ;IADJ,iDAAI;IACC,wDAAa;IAAC,oBAAY;IAAZ,0BAAY;EAC7E;EAED;;IAEW,sCAAK;IAAC,yCAAQ;IAAC,iBAAQ;IAAR,iBAAQ;IAAR,iBAAQ;IAAR,0CAAQ;IAAC,wDAAa;EAC/C;EAED;IACI;MACW,+CAAI;IACd;IAED;MACW,uCAAM;MAAC,UAAG;MACV;QAAA,yCAAmB;MAAA;MACnB;QAAA,uCAA6B;MAAA;IACvC;IAED;MACW,kBAAQ;MAAQ,uBAAO;MAAd,uCAAM;MAAwC,UAAG;MAAlC,+CAAgB;MAAhB,sDAAgB;MAAC,wDAAa;IAChE;EACJ;EAED;IACI;MACW,gDAAI;IACd;IAED;MACW,kBAAQ;MAAS,uBAAO;MAAf,wCAAO;MAAS,+CAAgB;MAAhB,sDAAgB;MAAC,eAAc;MAAC,wDAAa;MAAC;QAAA;UAAA,wDAAmB;QAAA;MAAA;IACpG;EACJ;EAED;IACW,kBAAQ;IAAS,uBAAO;IAAf,wCAAO;IAA0B,wBAAkB;IAAnC,+CAAgB;IAAhB,sDAAgB;EACnD;EAED;IACI;MACW,6DAAc;MAAC;QAAA,6DAAoB;MAAA;IAC7C;IAED;MACW,sDAAY;MAAC;QAAA,sDAAuB;MAAA;IAC9C;EACJ;AACJ;AAED;EACW,6CAAI;EAAC,kCAAO;EAAP,2EAAO;EAAC,sDAAY;AACnC;AA3DwE;EAAA,WAAO;EAAP,eAAO;EAAP,oBAAO;AAAA;AAEjD;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,sBAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,sBAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,kBAAY;EAAZ,eAAY;EAAZ,kBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAMvB;EAAA,WAAgB;EAAhB,eAAgB;EAAhB,gBAAgB;AAAA;AAAhB;EAAA,WAAgB;EAAhB,eAAgB;EAAhB,gBAAgB;AAAA;AAAhB;EAAA,WAAgB;EAAhB,eAAgB;EAAhB,gBAAgB;AAAA;AAAC;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAwB;EAAA,WAAY;EAAZ,eAAY;AAAA;AAKpD;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AAAR;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AAAR;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AAbmC;EAAA;IAAA;MAAA,yBAAO;MAEjD,sBAAY;MAAZ,0BAAY;MAAZ,uBAAY;MAAZ,4BAAY;MAAZ,gCAAY;MAAZ,6BAAY;MAAZ,wBAAY;MAAZ,2BAAY;MAAZ,8BAAY;MAAZ,iCAAY;MAAZ,wBAAY;MAAZ,2BAAY;MAAZ,4BAAY;MAAZ,kCAAY;MAMvB,mBAAgB;MAAhB,mBAAgB;MAAhB,mBAAgB;MAAC,sBAAS;MAAT,sBAAS;MAAT,sBAAS;MAAT,oBAAS;MAAT,oBAAS;MAAwB,sBAAY;MAKpD,eAAQ;MAAR,eAAQ;MAAR,eAAQ;IAb0C;EAAA;AAAA","sourcesContent":[null,"@reference '../../../assets/css/main.css'\r\n\r\n.input-floating-wrapper {\r\n    @apply w-full;\r\n}\r\n\r\n.input-floating {\r\n    @apply relative;\r\n\r\n    input {\r\n        @apply bg-white block w-full appearance-none rounded border-none outline outline-gray-300 px-2 py-1 h-9\r\n        text-gray-900\r\n        focus:outline-gray-500 focus:ring-0 hover:outline-gray-500;\r\n        @apply disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400;\r\n    }\r\n\r\n    label {\r\n        @apply absolute pointer-events-none left-0 px-2 mb-0! top-1/2\r\n        origin-left -translate-y-1/2 transform bg-white text-gray-400 duration-200;\r\n    }\r\n\r\n    input:focus ~ label,\r\n    input:not(:placeholder-shown) ~ label {\r\n        @apply top-0 left-0.5 scale-90 text-gray-500;\r\n    }\r\n\r\n    &.has-icon {\r\n        input {\r\n            @apply pl-8;\r\n        }\r\n\r\n        label {\r\n            @apply left-7 z-1;\r\n            @apply peer-focus:left-2.5;\r\n            @apply peer-placeholder-shown:left-5;\r\n        }\r\n\r\n        .input-icon {\r\n            @apply absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 z-2;\r\n        }\r\n    }\r\n\r\n    &.has-clear-icon {\r\n        input {\r\n            @apply pr-8;\r\n        }\r\n\r\n        .clear-icon {\r\n            @apply absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400 hover:text-gray-700;\r\n        }\r\n    }\r\n\r\n    [ng-transclude] {\r\n        @apply absolute right-1 top-1/2 -translate-y-1/2 h-[calc(100%-2px)];\r\n    }\r\n\r\n    &.has-error {\r\n        input {\r\n            @apply border-red-500 focus:border-red-600;\r\n        }\r\n\r\n        label {\r\n            @apply text-red-500 peer-focus:text-red-600;\r\n        }\r\n    }\r\n}\r\n\r\n.input-error-message {\r\n    @apply mt-1 text-xs text-red-500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
